var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeadBar'),_c('HeadNav'),_c('Map',{on:{"showList":_vm.showList}}),_c('LabList',{attrs:{"data":_vm.laboratory}}),_c('FootBar',{staticClass:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }